import Constants, { fixProtocol } from '../../../constants/constants';
import { httpGet } from '../../../modules/api/axios_api';

export const checkForPlayerNameDup = async (query: string) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/check-player-name-dup`);

  url.searchParams.append('query', query);

  return httpGet(url.toString())
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new Error('Error getting patient list', error);
    });
};
